import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementProfileAddress } from '../shared/model/profile/address/form-element-profile-address.model';

@Component({
  selector: 'wl-form-builder-profile-address-display-element',
  templateUrl: 'form-builder-profile-address-display-element.component.html',
    standalone: false
})
export class FormBuilderProfileAddressDisplayElementComponent {
  @Input('profileAddressSettings') profileAddressSettings: FormElementProfileAddress;
  private _translationService: TranslationService;

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
    this.profileAddressSettings = new FormElementProfileAddress();
  }

  ngOnInit(): void {}
}
